









































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Broadcast extends Vue {
    loading = false
    formValid = false
    chip = false;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {
        typeId: {
            id: null
        }
    }

    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ]
    }

    uploadFile () {
        this.loading = true
        this.$store
            .dispatch('createBroadcast', {
                uploadfile: this.formData.uploadfile
            })
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully! suscriptions founds: ' + resp.data.subscriptions + ' total messages:' + resp.data.total)
                    this.formData.uploadfile = null
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const refForm: any = this.$refs.form
                    refForm.reset()
                } else {
                    this.$store.commit('reportError', 'File NOT save.')
                }
                this.loading = false
            })
        this.loading = false
    }
}
